<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <label class="searchItemName">订单号：</label>
        <el-input class="input-box" placeholder="订单编号" v-model="queryParams.orderNumber" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <div>
        <label class="searchItemName">付款人：</label>
        <el-input class="input-box" placeholder="姓名" v-model="queryParams.idName" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="orderNumber" label="订单编号" width="160" align="center"></el-table-column>
      <el-table-column prop="idName" label="付款人" width="120" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道" width="150" align="center"></el-table-column>
      <el-table-column label="退款金额" width="110" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.refundAmount) }}</template>
      </el-table-column>
      <el-table-column prop="reason" label="退款原因" min-width="180" align="center"></el-table-column>
      <el-table-column prop="operaterName" label="操作人" width="120" align="center"></el-table-column>
      <el-table-column prop="refundTime" label="退款时间" width="170" align="center"></el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      channels: [],
      queryParams: { pageIndex: 1, pageSize: 10, channelId: '', orderNumber: '', idName: '' },
      tableData: []
    }
  },
  created() {
    this.loadChannels()
    this.GetData()
  },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadChannels() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})
    },
    GetData() {
      const loading = this.openLoading()
      post(505, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        channelId: this.queryParams.channelId || 0,
        orderNumber: (this.queryParams.orderNumber || '').trim(),
        idName: (this.queryParams.idName || '').trim()
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    }
  }
}
</script>
